import { render, staticRenderFns } from "./VxTableSort.vue?vue&type=template&id=bd1c1110&scoped=true&"
import script from "./VxTableSort.vue?vue&type=script&lang=js&"
export * from "./VxTableSort.vue?vue&type=script&lang=js&"
import style0 from "./VxTableSort.vue?vue&type=style&index=0&id=bd1c1110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1c1110",
  null
  
)

export default component.exports